// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kprW9E-8kWzhaPGf0B_bH","btn-prev-day":"_3mN88K6a_5jxJ1YCojZmuy","btn-next-day":"_3Fsaso-t3avm9sJ-c0xc3u","menu-full-site":"_1hpzKenre5WN_goLxNEci2"};